<template>
    <section class="expertises section-padding background-bleu d-flex justify-content-center align-items-center">
        <div class="add-padding">
            <div class="formation-modules mb-3">
                <h2 class="sous-section">
                    <span class="span-background-blue">
                        soft skills
                    </span>
                </h2>
                <h4 class="text-center mb-3">Découvrez nos programmes de formation détaillés Soft Skills.</h4>
            </div>
            <div class="row  mt-3 pt-3 d-flex justify-content-center align-items-center">
                <div v-for="(item, index) in allTraining" :key="item.id" class="col-md-4 col-sm-4 mb-4">
                    <div class="item mb-4">
                        <a :href="`https://emci.catalogueformpro.com/${item.category.order}/${generateUrlParam(item.category.name)}/${item.id}/${generateUrlParam(item.name)}`"
                            target="_blank">
                            <div class="card-block">
                                <img src="/images/pages/softskills/programs1.jpg" alt="Formation"
                                    v-if="item.image === null" />
                                <img :src="`${item.image.url}`" :alt="item.name" v-if="item.image !== null">
                                <div class="bodyCard hover tran3s d-flex flex-column">
                                    <div class="text-start">
                                        <h5 class="mb-3">{{ item.name }}</h5>
                                    </div>
                                    <div class="text-start">
                                        <p><i class="fa-solid fa-user me-2"></i>
                                            Formation
                                            {{
                    item.trainingPedagogicalModality === 0
                        ? "présentielle"
                        : item.trainingPedagogicalModality === 1
                            ? "mixte"
                            : "à distance"
                }}
                                        </p>
                                        <p><i class="fa-regular fa-clock me-2"></i>Durée : {{ item.durationInHours
                                            }}
                                            heures
                                            ({{
                    item.durationInDays }} jours)</p>
                                        <p v-if="item.cpf === true">CPF #{{ item.cpfCode }}</p>
                                        <p><i class="fa-solid fa-universal-access me-2"></i> </p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const query = gql`
query {
  programs(
    filter: {name: "1.%"}
    dateFilters: { createdAfter: "2020-12-01" },
  ) {
    id
    name
    durationInHours
    durationInDays
    image {
      url
    }
    onSale
    cpf
    cpfCode
    trainingPedagogicalModality
    category {id name order}
  }
}
`
const { data } = await useAsyncQuery(query)
const allTraining = data.value.programs.filter(program => program.name.startsWith("1.") && program.onSale === true);

</script>
<style scoped>
.formation-modules>* {
    margin-bottom: -20px;
}

.row {
    background-color: #FFFF;
    padding-left: 0px;
    padding-right: 50px;
}

.item {
    width: 100%;
}

img {
    width: 100%;
}



.sous-section {
    margin: 1.22rem 0;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    color: var(--accent, #25233E);
    line-height: 111.5%;
    text-transform: uppercase;
}


.section-padding {
    margin-top: -80px;
}


.add-padding {
    padding: 0 210px;
    padding-top: 50px !important;
}


.item {
    border-radius: 0.5625rem;
    background: #FFF;
    box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.08);
}

.bodyCard {
    padding: 0.45rem 1.0625rem;
    row-gap: 1rem;
    height: 200px;
}


@media only screen and (min-width: 300px) and (max-width: 768px) {
    .add-padding {
        padding: 0px 10px;
        padding-bottom: 3rem;
    }

    h4 {
        font-size: 15px;
    }

    .btn-item {
        gap: 10px;
    }

    .d-flex {
        max-width: 100%;
        margin: 0 5px;
        text-align: center;
    }

    .sous-section {
        font-size: 15px;
    }

    .item {
        margin: 0px 2px;
    }

    .bodyCard {
        height: auto;
    }

    .pb-70 {
        padding-bottom: 1px;
    }

    .row {
        padding-right: 0px;
    }
}

@media only screen and (min-width: 769px) {
    .add-padding {
        padding: 0px 10px;
        padding-bottom: 3rem;
    }

    h4 {
        font-size: 15px;
    }

    .d-flex {
        max-width: 80%;
        margin: auto;
        text-align: center;
    }

    .bodyCard {
        height: 265px;
    }



    .sous-section {
        font-size: 20px;
    }

    .item {
        margin: 0px 10px;
    }
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {
    .add-padding {
        padding: 0px 10px;
        padding-bottom: 3rem;
    }

    h4 {
        font-size: 15px;
    }

    .btn-item {
        gap: 10px;
    }

    .d-flex {
        max-width: 80%;
        margin: auto;
        text-align: center;
    }



    .sous-section {
        font-size: 20px;
    }

    .item {
        margin: 0px 10px;
    }

    .title {
        font-size: 17px !important;
    }

    .subtitle {
        font-size: 15px !important;
        ;

    }
}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .add-padding {
        padding: 0px 210px;
        padding-bottom: 3rem !important;
    }

    h4 {
        font-size: 17px;
    }

    .d-flex {
        max-width: 100%;
        margin: auto;
        text-align: center;
    }

    .sous-section {
        font-size: 25px;
    }



    .item {
        margin: 0px 10px;
    }
}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {
    .add-padding {
        padding: 0px 290px;
        padding-bottom: 3rem !important;
    }

    h4 {
        font-size: 17px;
    }

    .d-flex {
        max-width: 100%;
        margin: auto;
        text-align: center;
    }

    .sous-section {
        font-size: 25px;
    }



    .item {
        margin: 0px 10px;
    }
}

/** ecran 1280 * 1024  */

@media screen and (min-width: 1088px) and (max-width: 1381px) {
    h5 {
        font-size: 1.063rem;
    }
}
</style>